import type { Components, Theme } from '@mui/material/styles';

import { token, WEIGHT } from './scales';

/** The kit media: the poster play button and duration, and the video player. */
export const MEDIA: Components<Theme> = {
  KitMediaPoster: {
    styleOverrides: {
      play: {
        color: token('on-filled'),
        backgroundColor: token('on-filled', 0.25),
        backdropFilter: 'blur(8px)',
        '& svg': { fill: 'currentColor' },
      },
      duration: ({ theme }) => ({
        fontFamily: 'var(--font-mono)',
        fontSize: theme.typography.tag.fontSize,
        fontWeight: WEIGHT.medium,
        color: token('on-filled'),
        backgroundColor: token('media-scrim', 0.7),
      }),
    },
  },
  KitVideoPlayer: {
    styleOverrides: { root: { backgroundColor: token('media-scrim') } },
  },
};
